import { render, staticRenderFns } from "./SpecialtySubscriptionModal.vue?vue&type=template&id=b8d21efa&scoped=true"
import script from "./SpecialtySubscriptionModal.vue?vue&type=script&lang=js"
export * from "./SpecialtySubscriptionModal.vue?vue&type=script&lang=js"
import style0 from "./SpecialtySubscriptionModal.vue?vue&type=style&index=0&id=b8d21efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d21efa",
  null
  
)

export default component.exports